import React, { memo } from "react";
import { BaseEdge, EdgeLabelRenderer, EdgeProps } from "reactflow";
import useFlowsStore from "../../store/storeFlows";
import { getEdgePath } from "./utils";
import EdgeDeleteButton from "./EdgeDeleteButton";

interface EdgeBaseWrapperProps extends EdgeProps {
  children?: React.ReactNode;
  renderLabel?: (coords: { x: number; y: number }) => React.ReactNode;
  showDeleteButton?: boolean;
}

const EdgeBaseWrapper = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  style,
  markerEnd,
  markerStart,
  interactionWidth = 20,
  children,
  renderLabel,
  showDeleteButton = true,
}: EdgeBaseWrapperProps) => {
  const { lineType } = useFlowsStore((state) => state);
  const adjustedTargetY = targetY - 5;

  const [edgePath, labelX, labelY] = getEdgePath(lineType, {
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY: adjustedTargetY,
    targetPosition,
  });

  return (
    <>
      {children}

      <BaseEdge
        id={id}
        path={edgePath}
        interactionWidth={interactionWidth}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={style}
      />

      <EdgeLabelRenderer>
        {selected && showDeleteButton && (
          <EdgeDeleteButton id={id} labelX={labelX} labelY={labelY} />
        )}
        {renderLabel?.({ x: labelX, y: labelY })}
      </EdgeLabelRenderer>
    </>
  );
};

export default memo(EdgeBaseWrapper);
